/* src/app/private/shared/component/header/header.component.scss */
.app-header {
  background-color: var(--top-bar-background);
  color: white;
}
.icon-container {
  align-items: center;
  gap: 15px;
}
.icon-container div {
  position: relative;
  padding: 0 0px;
}
.icon-container div:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -10px;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #fff;
}
.location-select {
  border-radius: 30px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) inset;
  font-weight: 500;
  padding: 0px 7px;
  padding-top: 1px;
}
.p-overlay-badge > .p-badge {
  background-color: red !important;
}
#pn_id_7_badge {
  background-color: red !important;
}
/*# sourceMappingURL=header.component.css.map */
